<template>
  <div class="album">

    <img :src="art" class="mb-auto" loading="lazy" >
    <p>{{ album.title }}</p>
  </div>
</template>

<script lang="ts">
import { ref } from 'vue';

import { AlbumEntry } from '@/store/MusicStore';
import { getAlbumArt } from '@/util/metadataUtilities';

export default {
  setup() {
    return {
      art: ref<string>(null)
    };
  },
  props: {
    album: {
      type: Object as () => AlbumEntry,
      required: true
    }
  },
  async created() {
    this.art = await getAlbumArt(this.$props.album);
  }
};

</script>

<style lang="scss" scoped>
.album {
  //margin: 0.5rem;
  height: auto;
  position: relative;

  border: 1px solid black;
  background-color: #eee;

  &.current:after {
    $sz: 15px;

    content: '';
    width: 0;
    height: 0;
    border-left: $sz solid transparent;
    border-right: $sz solid transparent;
    border-bottom: $sz solid black;
    position: absolute;
    bottom: -21px;
    z-index: 0;

    left: 50%;
    margin-left: -$sz;
    overflow: visible;
  }

  &:before {
    content: '';
    display: table;
    padding-top: 100%;
  }

  img {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    width: 100%;
  }
}
</style>
